import { render, staticRenderFns } from "./WapWXCW03BJRecord4Hour.vue?vue&type=template&id=c96c216c&scoped=true&"
import script from "./WapWXCW03BJRecord4Hour.vue?vue&type=script&lang=js&"
export * from "./WapWXCW03BJRecord4Hour.vue?vue&type=script&lang=js&"
import style0 from "./WapWXCW03BJRecord4Hour.vue?vue&type=style&index=0&id=c96c216c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96c216c",
  null
  
)

export default component.exports